import { comparePosition } from "./comparePosition"

export function sortByPosition(array: null | undefined): null
export function sortByPosition<T extends { position: number }>(array: T[]): T[]
export function sortByPosition<T extends { position: number }>(
  array: T[] | null | undefined
): T[] | null
export function sortByPosition<T extends { position: number }>(
  array: T[] | null | undefined
): T[] | null {
  if (!array) {
    return null
  }
  return array.sort(comparePosition)
}

export function sortByPositionAndUpdateIndex(array: null | undefined): null
export function sortByPositionAndUpdateIndex<T extends { position: number }>(
  array: T[]
): T[]
export function sortByPositionAndUpdateIndex<T extends { position: number }>(
  array: T[] | null | undefined
): T[] | null
export function sortByPositionAndUpdateIndex<T extends { position: number }>(
  array: T[] | null | undefined
): T[] | null {
  if (!array) {
    return null
  }
  return (
    sortByPosition(array)?.map((c, index) => ({ ...c, position: index })) || []
  )
}
